import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RetirementHealthcareCostsComponent } from '../retirement-healthcare-costs/retirement-healthcare-costs.component';


@Component({
  selector: 'app-in-retirement-healthcare-expenses-future',
  templateUrl: './in-retirement-healthcare-expenses-future.component.html',
  styleUrls: ['./in-retirement-healthcare-expenses-future.component.scss']
})
export class InRetirementHealthcareExpensesFutureComponent implements OnInit {

  isFuture: boolean;
  displayedColumns: string[] = ['year(age)', 'partB', 'partD','copaysAndDeductibles', 'total'];
  dataSource;
  presentDollarDataSource;
  futureDollarDataSource;
  expenseDetails;
  isMarried: boolean;
  isMobile: boolean;
  
  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<InRetirementHealthcareExpensesFutureComponent>, 
    @Inject(MAT_DIALOG_DATA) public data) { 
      this.presentDollarDataSource = data.inRetirementHCExps;
      this.futureDollarDataSource = data.futureInRetirementHCExps;
      this.expenseDetails = data.expenseDetails;
      this.dataSource = this.presentDollarDataSource;

      if (window.innerWidth < 767) {
        this.isMobile = true;
        this.displayedColumns = ['year(age)', 'total'];
      } else {
        this.isMobile = false;
        this.displayedColumns = ['year(age)', 'partB', 'partD','copaysAndDeductibles', 'total'];
      }
      
    }

  ngOnInit(): void {
    this.isMarried = this.presentDollarDataSource.inRetirementHCExp[0].spouseAge > 0;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  toggle(){
    this.isFuture = !this.isFuture;
    if (this.isFuture) {
      this.dataSource = this.futureDollarDataSource;
    } else {
      this.dataSource = this.presentDollarDataSource;
    }
  }

  inRetirementCostInfo() {
    let dialogRef = this.dialog.open(RetirementHealthcareCostsComponent, {
      height: '210px',
      width: '600px',
    }); 
  }

}
